<template>
	<div class="memo-info-box">
		<div class="fx-title" style="margin-top:25px">
			<p>附属信息</p>
		</div>
		<div class="info-box">
			<div><span class="info-title">退货类型：</span>
				<div>
					代客退单
				</div>
			</div>
			<div><span class="info-title">退款方式：</span>
				<div>
					<el-select
						class="info-select"
						size="small"
						v-model="refundType"
						filterable
						clearable
						placeholder="请选择退款方式"
						@change="changeRefundType(refundType)"
						disabled
						:popper-append-to-body="true">
						<el-option
							v-for="(item, index) in refundTypeList"
							:key="index"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
			</div>
			<div><span class="info-title"><span style="color:red;">*</span>退款原因：</span>
				<div>
					<el-select
						class="info-select"
						size="small"
						v-model="refundCause"
						filterable
						clearable
						placeholder="请选择退款原因"
						@change="changeRefundCause(refundCause)"
						:disabled="!acountValue"
						:popper-append-to-body="true">
						<el-option
							v-for="(item, index) in refundCauseList"
							:key="index"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
			</div>
			<div><span class="info-title">物流公司：</span>
				<div>
					<el-select
						class="info-select"
						size="small"
						v-model="companycode"
						filterable
						clearable
						placeholder="请选择物流公司"
						@change="changeCompanycode(companycode)"
						:disabled="!acountValue"
						:popper-append-to-body="true">
						<el-option
							v-for="(item, index) in companycodeList"
							:key="index"
							:label="item.value"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
			</div>
			<div><span class="info-title">物流单号：</span>
				<div>
					<el-input
						class="info-select"
						size="small"
						v-model="code"
						@change='changeCode'
						placeholder="请填写物流单号"
						:disabled="!acountValue"
						onkeyup="value=value.replace(/[^a-zA-Z0-9]/ig,'')"
						oninput="if(value.length>50)value=value.slice(0,50)">
					</el-input>
				</div>
			</div>
			<div class="total-memo"><span class="info-title">附件：</span>
				<div class="img-container">
					<ImgUpload
						class="show-img"
						v-for="(item, index) in showSrc"
						:key="index"
						:imgSrc.sync="item.imgurl"
						:imgId.sync="item.id"
						:location="index"
						:uploadError.sync="item.uploadError"
						@deletImg="deletImg"
						@uploadNewImg="uploadNewImg"
						ref="showUpload"
					/>
					<ImgUpload2
						class="show-img"
						v-if="showSrc.length < 3"
						:acountValue='acountValue'
						@uploadNewImg="uploadNewImg"
						ref="showUpload2"
					/>
					<div class="img-tip">支持的图片格式：jpg、jpeg、png，图片大小1M以内，最多上传3张</div>
				</div>
			</div>
			<div class="total-memo"><span class="info-title"><span style="color:red;">*</span>问题描述：</span>
				<el-input
					type="textarea"
					placeholder="最大200字"
					maxlength="200"
					resize="none"
					rows="3"
					v-model="textarea"
					:disabled="!acountValue"
					class="info-textarea">
				</el-input>
			</div>
		</div>
	</div>
</template>

<script>
import ImgUpload from '@/components/valetRefundOrder/ImgUpload.vue'
import ImgUpload2 from '@/components/valetRefundOrder/ImgUpload2.vue'
export default {
	name: 'memoInfo',
	components: {
		ImgUpload, ImgUpload2
	},
	props: {
		acountValue: {
			type: String
		},
		orderobj: {
			type: Object
		},
		wechatflag: {
			type: Number
		}
	},
	data () {
		return {
			refundType: '',
			companycode: '',
			refundCause: '',
			code: '',
			textarea: '',
			showSrc: [],
			refundTypeList: [
				{ id: '0', name: '线下' },
				{ id: '1', name: '吾享' },
				{ id: '2', name: '微信' },
				{ id: '3', name: '支付宝' },
				{ id: '4', name: '预付货款' },
				{ id: '6', name: '微企付' }
			],
			refundCauseList: [
				{ id: '0', name: '无理由退货' },
				{ id: '1', name: '质量问题' },
				{ id: '2', name: '与商品描述不符合' },
				{ id: '3', name: '卖家发错货' },
				{ id: '4', name: '发票问题' },
				{ id: '5', name: '其他' }
			],
			companycodeList: [
				{ 'id': 'shunfeng,顺丰', 'value': '顺丰' },
				{ 'id': 'yuantong,圆通', 'value': '圆通' },
				{ 'id': 'yunda,韵达', 'value': '韵达' },
				{ 'id': 'shentong,申通', 'value': '申通' },
				{ 'id': 'huitongkuaidi,百世', 'value': '百世' },
				{ 'id': 'zhongtong,中通', 'value': '中通' },
				{ 'id': 'ems,EMS', 'value': 'EMS' },
				{ 'id': 'debangwuliu,德邦', 'value': '德邦' },
				{ 'id': 'debangkuaidi,德邦快递', 'value': '德邦快递' },
				{ 'id': 'youzhengbk,邮政标准快递', 'value': '邮政标准快递' },
				{ 'id': 'zhaijisong,宅急送', 'value': '宅急送' },
				{ 'id': '0,其他', 'value': '其他' }
			],
			express: {
				companycode: '',
				companyname: '',
				number: ''
			}
		}
	},
	watch: {
		acountValue (val) {
			if (!val) {
				this.showSrc = []
			} else {
				this.refundType = this.orderobj.refundMode + ''
			}
		}
	},
	created () {
	},
	methods: {
		uploadNewImg (oldUrl, index) {
			let needUrl = `${this.$fxBaseApi.urlQIVShop}/replacerefundorder/upload`
			var formData = new FormData()
			if (oldUrl === '') {
				formData.append('extension', this.$refs.showUpload2.fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload2.fileFiles)
			} else {
				formData.append('extension', this.$refs.showUpload[index].fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload[index].fileFiles)
			}
			formData.append('oldUrl', oldUrl)
			this.$store.dispatch('requestFilePost', {
				url: needUrl,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success('上传图片成功')
					let img = { imgurl: res.data, id: this.showSrc.length + '', uploadError: false }
					if (oldUrl === '') {
						this.showSrc.push(img)
					} else {
						this.showSrc.splice(index, 1, img)
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		deletImg (index, path) {
			index = +index
			let params = {
				deletePath: path
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replacerefundorder/remove`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功')
					this.showSrc.splice(index, 1)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		changeRefundType (val) {
			// console.log(val)
		},
		changeCompanycode (val) {
			let companycodeArr = val.split(',')
			// let express = {
			this.express.companycode = companycodeArr[0]
			this.express.companyname = companycodeArr[1]

			// }
			this.$emit('express', this.express)
		},
		changeCode () {
			this.express.number = this.code
			this.$emit('express', this.express)
		},
		changeRefundCause (val) {
			// console.log(val)
		},
		clearAll () {
			this.refundType = ''
			this.refundCause = ''
			this.companycode = ''
			this.code = ''
			this.textarea = ''
			this.showSrc = []
		}
	}
}
</script>

<style lang="stylus" scoped>
.memo-info-box {
	padding-left: 10px
	font-size: 14px
	margin-top: 10px
	text-align: left
	padding-bottom: 20px
	.fx-title {
		font-weight: 700
		margin: 10px 0 10px 0
	}
	.info-box {
		text-align: left
		&>div {
			display: flex
			align-items: center
			padding-left: 14px
			margin-top: 20px
			&.total-memo {
				align-items: flex-start
			}
		}
		.info-title {
			text-align :right;
			width :100px;
			margin-right: 10px
		}
		.info-textarea {
			width: 350px
		}
	}
	.img-tip {
		clear: both;
		color: #999
	}
}
</style>
